var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next, jumper","hide-on-single-page":"","total":_vm.total,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }